import {Validator} from 'vee-validate'
import {store} from 'src/store/store'

export function minFields(type) {
  Validator.extend('minFields', () => {
    let config = {
      valid: false,
      data: {
        required: true
      }
    }
    let module
    switch (type) {
      case 'idaArchive':
      case 'priceRules':
      case 'planNames':
      case 'jobTemplates':
      case 'logs':
        module = type
        break
      case 'invoices':
        module = type + '/create'
        break
      default:
        module = type + '/search'
    }
    if (store.getters[module + '/searchFieldsHaveValues']) {
      config = {
        valid: true,
        data: {
          required: false
        }
      }
    }
    return config
  }, {
    computesRequired: true
  })
}

export function planNameOrNumber(store) {
  Validator.extend('validNameOrNumber', () => {
      let config = {
        valid: false,
        data: {
          required: true
        }
      }
      if (!!store.get('planNames/edit@name') || !!store.get('planNames/edit@number')) {
        config = {
          valid: true,
          data: {
            required: false
          }
        }
      }
      return config
    },
    {
      computesRequired: true
    })
}

export function metadataNameExists(entity) {
  Validator.extend('nameExists', {
    getMessage() {
      return 'Duplicate names not permitted.'
    },
    validate(value) {
      return !store.getters['metadata/nameExists']({entity: entity, name: value})
    }
  })
}
